import TableAntecipe from "~/components/tables/TableAntecipe"

const Requests = () => {
  return <TableAntecipe />
}

export default Requests;